<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="row custom-header">
          <div class="col-11">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-1">
            <a href="#" class="custom-close" @click="close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </template>
      <template #body>
        <div class="row">
          <div class="col" v-html="content"></div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col-6"></div>
          <div class="col-6">
            <div class="custom-footer-buttons">
              <button class="btn btn-light" @click="close">Finished</button>
            </div>
          </div>
        </div>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState } from 'pinia'
import { blogStore } from '@/stores/blog'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
export default {
  name: 'BlogView',
  components: {
    ZDialog
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalSize: 'modal-lg'
    }
  },
  emits: ['close'],
  computed: {
    ...mapState(blogStore, ['blog']),
    isVisible() {
      return this.modelValue ? this.modelValue : false
    },
    title() {
      let _data = null
      if (this.blog) {
        _data = this.blog.blogName
      }
      return _data
    },
    content() {
      let _data = null
      if (this.blog) {
        _data = this.blog.content
      }
      return _data
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}
.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}
.custom-footer {
  width: 100%;
  display: inline-flex;
}
.custom-footer-buttons {
  position: relative;
  float: right;
}
</style>
